module.exports = __webpack_public_path__ + "img/1920_cd.7e0d7792.jpeg";